import { get, BaseUrl, } from './api'
export const getCountries = async () => {
    return await get(`api/Country/`, null,
        BaseUrl.Centerpoint);
}